<div class="pmd-loader" *ngIf="isLoading | async">
  <div class="loader" aria-label="Data is loading...">
    <img
      src="assets/images/probanker-logo-icon.svg"
      alt="Probanker Logo"
      class=""
      aria-hidden="true"
    />
    <svg class="circular" viewBox="25 25 50 50" aria-hidden="true">
      <circle
        class="path"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke-width="2"
        stroke-miterlimit="10"
        aria-hidden="true"
      />
    </svg>
  </div>
</div>
